<script>
  import FormSubmitActions from '@/utils/actions/form_submit_actions'

  export default {
    name: 'NotionCallback',
    async created() {
      const formId = localStorage.getItem('formId')
      const userId = localStorage.getItem('userId')
      const urlParams = new URLSearchParams(window.location.search)
      const code = urlParams.get('code')

      await this.exchangeCode(code, formId, userId)
    },
    methods: {
      async exchangeCode(code, formId, userId) {
        try {
          await FormSubmitActions.exchangeNotionCode(code, formId, userId)
        } catch (error) {
          console.error('Error during Notion connection:', error)
        } finally {
          this.closePopupWindow()
        }
      },
      closePopupWindow() {
        if (window.opener) {
          window.opener.postMessage('login-success', '*')
          window.close()
        }
      },
    },
  }
</script>

<template>
  <div></div>
</template>
